<template>
    <div :style="divStyle">
        <Spin fix v-show="isSpinShow">
            <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
            <div>Loading</div>
        </Spin>
        <p>当前正在进行第 {{ current + 1 }} 步</p>
        <Steps :current="current">
            <Step title="步骤-1" content="选择操作指令及设备信息"></Step>
            <Step title="步骤-2" content="查看设备"></Step>
            <Step title="步骤-3" content="输入参数并执行"></Step>
        </Steps>
        <div style="width:30%; left:30%; position:relative; margin-top:15px;" v-show="step[0]">
            <Form ref="formSearch" :label-width="120" :model="formSearch" :rules="formSearchRule">
                <FormItem label="下发指令：" prop="command">
                    <Select :transfer="true" v-model="formSearch.command" :label-in-value="true">
                        <OptionGroup label="参数设置">
                            <Option v-for="(value, key) in opType1" :value="JSON.stringify(value)" :key="key" v-if="value.down !== ''">{{key}}</Option>
                        </OptionGroup>
                        <OptionGroup label="设备控制">
                            <Option v-for="(value, key) in opType2" :value="JSON.stringify(value)" :key="key" v-if="value.down !== ''">{{key}}</Option>
                        </OptionGroup>
                        <OptionGroup label="使用信息">
                            <Option v-for="(value, key) in opType3" :value="JSON.stringify(value)" :key="key" v-if="value.down !== ''">{{key}}</Option>
                        </OptionGroup>
                        <!--OptionGroup label="设备监控">
                            <Option v-for="(value, key) in opType4" :value="JSON.stringify(value)" :key="key" v-if="value.down !== ''">{{key}}</Option>
                        </OptionGroup-->
                    </Select>
                </FormItem>
                <FormItem label="批量筛选方式：" prop="selectCondition">
                    <Select v-model="formSearch.selectCondition" @on-change="onSelectChange">
                        <Option value="batch">按批次</Option>
                        <Option value="address">按地址</Option>
                    </Select>
                </FormItem>
                <FormItem label="输入或选择条件：" prop="condition">
                    <div v-if="formSearch.selectCondition == 'batch'">
                        <Row type="flex" justify="center" align="bottom" :gutter="16">
                            <Col span=8 style="text-align: right;">
                            生产批次
                            </Col>
                            <Col span=16>
                            <Tooltip disabled>
                                <Input v-model="formSearch.produceBatch" placeholder="请输入6位生产批次号"></Input>
                            </Tooltip>
                            </Col>
                        </Row>
                        <Row type="flex" justify="center" align="bottom" :gutter="16">
                            <Col span=8 style="text-align: right;">
                            序号
                            </Col>
                            <Col span=16>
                            <Tooltip max-width="200" content="例:输入1-28,55,60-99  代表筛选1到28,55,60到99的数据">
                                <Input v-model="formSearch.produceIndex" placeholder="请输入生产序号"></Input>
                            </Tooltip>
                            </Col>
                        </Row>
                    </div>
                    <Cascader :data="addressData" change-on-select filterable transfer @on-change="chooseAddress" v-if="formSearch.selectCondition == 'address'"></Cascader>
                </FormItem>
            </Form>
        </div>
        <div v-if="step[1]">
            <p>将下发如下共{{dataCount}}个设备</p>
            <Table ref="selectionTable" :max-height="height" :data="showData" :columns="showColumns" stripe border></Table>
            <Page :current="currentPage" :total="dataCount" :page-size="pageSize" show-sizer show-total @on-change="changePage"
                @on-page-size-change="changePageSize" style="text-align:right"></Page>
        </div>
        <div v-if="step[2]">
            <Tabs ref="tabs">
                <TabPane label="指令下发">
                    <div style="width:100%; left:10%; position:relative; margin-top:10px; margin-left:35px;">
                        <anchored-heading-forlist :inputDatas="instructionInputList"></anchored-heading-forlist>
                    </div>
                </TabPane>
            </Tabs>
        </div>
        <div v-if="isButtonShow">
            <Button class="button" type="primary" @click="pre">上一步</Button>
            <Button class="button" type="primary" @click="next">下一步</Button>
        </div>
        <div v-if="!isButtonShow">
            <Button class="button" @click="showResult = true" type="primary">查看结果</Button>
            <Button class="button" @click="reflash" type="primary">返回</Button>
        </div>
        <Drawer width="340" title="指令下发结果" :closable="false" v-model="showResult">
            <p v-for="(value, key) in array" :key="key" :value="value">
                <span>
                    {{value.id + " "}}
                    <span v-if="value.state == '等待下发'" style="color:blue">{{value.state}}</span>
                    <span v-if="value.state == '下发成功'" style="color:green">{{value.state}}</span>
                    <span v-if="value.state != '下发成功' && value.state != '等待下发'" style="color:red">{{value.state}}</span>
                </span>
                <Icon color="blue" type="ios-loading" v-if="value.state == '等待下发'" size="18" class="demo-spin-icon-load"
                    style="margin-left:10px"></Icon>
                <Icon color="green" type="ios-checkmark-circle-outline" v-if="value.state == '下发成功'" size="18" style="margin-left:10px"></Icon>
                <Icon color="red" type="ios-close-circle-outline" v-if="value.state != '下发成功' && value.state != '等待下发'"
                    size="18" style="margin-left:10px"></Icon>
            </p>
        </Drawer>
    </div>
</template>

<script>
    import Vue from 'vue';
    var inputObject = {};
    var isNext = {};
    export default {
        name: "instructions_detailed_for_list",
        computed: {
            divStyle() {
                var style = {};
                if(this.$parent.$refs.mainContent){
                    style.width = this.$parent.$refs.mainContent.clientWidth - 54 + "px";
                }else{
                    style.width = window.innerWidth - 279 + "px";
                }
                //style.height = (this.$parent.$refs.mainContent.clientHeight - 54) + 'px';
                return style;
            }
        },
        mounted() {
            this.request();
        },
        data() {
            const validateCondition = (rule, value, callback) => {
                if (this.formSearch.selectCondition == "batch") {
                    let reg = /^\d{6}$/;
                    if (!this.formSearch.produceBatch ||
                        !reg.test(this.formSearch.produceBatch)) {
                        callback(new Error("请输入6位生产批次号..."));
                    } else if (!this.formSearch.produceIndex) {
                        callback(new Error("请输入生产序号..."));
                    } else {
                        this.formSearch.produceIndex = this.formSearch.produceIndex.replace(/，/g,",");
                        let indexArr = this.formSearch.produceIndex.split(",");
                        for (let i = 0; i < indexArr.length; i++) {
                            if (!indexArr[i]) {
                                callback(new Error("请输入正确的格式..."));
                            }
                            if (isNaN(indexArr[i] * 1)) {
                                let param = indexArr[i].split('-');
                                if (param.length != 2) {
                                    callback(new Error("请输入正确的格式..."));
                                } else {
                                    if (!param[0] || !param[1] || isNaN(param[0] * 1) || isNaN(param[1] * 1) ||
                                        param[0] * 1 <= 0 || param[0] * 1 % 1 !== 0 ||
                                        param[1] * 1 <= 0 || param[1] * 1 % 1 !== 0 || param[0] * 1 >= param[1] * 1
                                    ) {
                                        callback(new Error("请输入正整数..."));
                                    }
                                }
                            } else if (indexArr[i] * 1 <= 0 || indexArr[i] * 1 % 1 !== 0) {
                                callback(new Error("请输入正整数..."));
                            }
                        }
                    }
                    callback();
                } else if (this.formSearch.selectCondition == "address") {
                    if (!this.formSearch.addressDataSelect) {
                        callback(new Error("请选择地址..."));
                    } else {
                        callback();
                    }
                } else {
                    callback(new Error("请选择筛选方式..."));
                }
            };
            return {
                current: 0,
                isSpinShow: false,
                step: [true, false, false],
                height: window.innerHeight,
                formSearch: {
                    command: null,
                    selectCondition: "batch",
                    produceBatch: null,
                    produceIndex: null,
                    addressDataSelect: null
                },
                formSearchRule: {
                    command: [{
                        required: true,
                        message: '请选择操作方式',
                        trigger: 'change'
                    }],
                    condition: [{
                        required: true,
                        validator: validateCondition
                    }]
                },
                addressData: [],
                searchParam: {
                    selectCondition: "batch",
                    meterList: [],
                    addressId: null
                },
                currentPage: 1,
                dataCount: 0,
                pageSize: 10,
                showData: [],
                showColumns: [{
                        title: "设备编号",
                        key: "meterId"
                    },
                    {
                        width: 400,
                        title: "设备地址",
                        key: "addressLowestLevelAddressIds"
                    },
                    {
                        title: "用户姓名",
                        key: "customerName"
                    },
                    {
                        title: "设备类型",
                        key: "meterTypeName"
                    }
                ],
                meterIds: "",
                instructionInputList: [],
                opType1: global.commandop1,
                opType2: global.commandop2,
                opType3: global.commandop3,
                opType4: global.commandop4,
                inputParam: {},
                array: {},
                showResult: false,
                isButtonShow: true
            }
        },
        methods: {
            onSelectChange(){
                this.$refs["formSearch"].validate(valid => {});
            },
            reflash(){
                this.$parent.reloadPage();
            },
            chooseAddress(data) {
                if (data.length > 0) {
                    this.formSearch.addressDataSelect = data[data.length - 1] * 1;
                } else {
                    this.formSearch.addressDataSelect = null;
                }
            },
            showPage() {
                let that = this;
                that.isSpinShow = true;
                $.ajax({
                    url: "/api/instructionsForList/selectList?page=" +
                        that.currentPage +
                        "&pageAmount=" +
                        that.pageSize,
                    contentType: "application/json",
                    type: "post",
                    data: JSON.stringify(that.searchParam),
                    dataType: "json",
                    success: function(data) {
                        if (data.errorCode != 0) {
                            that.$Notice.error({
                                title: "异常",
                                desc: data.errorInfo
                            });
                            return;
                        }
                        that.showData = data.body.pager.resultList;
                        that.dataCount = data.body.pager.amount;
                        that.meterIds = data.body.meterIds;
                        if (that.meterIds) {
                            let meterList = {}
                            that.meterIds.split(",").map(item => {
                                let param = {
                                    id: item,
                                    state: "等待下发"
                                };
                                meterList[item] = param;
                            })
                            that.array = meterList;
                        }
                    },
                    error: function(textStatus) {
                        that.$Notice.error({
                            title: "异常",
                            desc: "接口请求异常"
                        });
                    },
                    complete: function() {
                        that.isSpinShow = false;
                    }
                });
            },
            changePage(index) {
                this.currentPage = index;
                this.showPage();
            },
            changePageSize(size) {
                this.pageSize = size;
                this.showPage();
            },
            pre() {
                var that = this;
                if (that.current == 1) {
                    that.current = 0;
                    that.step[1] = false;
                    that.step[0] = true;
                } else if (that.current == 2) {
                    that.current = 1;
                    that.step[2] = false;
                    that.step[1] = true;
                }
            },
            next() {
                var that = this;
                if (that.current == 0) {
                    that.$refs["formSearch"].validate(valid => {
                        if (valid) {
                            let meterList = null;
                            let addressId = null;
                            if (that.formSearch.selectCondition == "batch") {
                                let indexList = [];
                                let indexArr = that.formSearch.produceIndex.split(",");
                                for (let i = 0; i < indexArr.length; i++) {
                                    if (isNaN(indexArr[i] * 1)) {
                                        let param = indexArr[i].split('-');
                                        for (let j = param[0] * 1; j <= param[1] * 1; j++) {
                                            if (indexList.indexOf(j) == -1) {
                                                indexList.push(j);
                                            }
                                        }
                                    } else {
                                        if (indexList.indexOf(indexArr[i] * 1) == -1) {
                                            indexList.push(indexArr[i] * 1);
                                        }
                                    }
                                }
                                meterList = indexList.map(item => {
                                    let sup = "";
                                    while ((that.formSearch.produceBatch + sup + item).length < 14) {
                                        sup = sup + "0";
                                    }
                                    return that.formSearch.produceBatch + sup + item;
                                });
                                that.searchParam.selectCondition = "batch";
                                that.searchParam.meterList = meterList;
                            } else if (that.formSearch.selectCondition == "address") {
                                addressId = that.formSearch.addressDataSelect;
                                that.searchParam.selectCondition = "address";
                                that.searchParam.addressId = addressId;
                            }
                            that.current = 1;
                            that.step[0] = false;
                            that.step[1] = true;
                            that.showPage();
                        }
                    });
                } else if (that.current == 1) {
                    that.current = 2;
                    that.step[1] = false;
                    that.step[2] = true;
                    that.isSpinShow = true;
                    $.ajax({
                        url: "/api/instructions/downInstruction",
                        contentType: "application/json",
                        type: "post",
                        data: JSON.stringify({
                            commandType: JSON.parse(that.formSearch.command).down
                        }),
                        dataType: "json",
                        success: function(receiveData) {
                            if (receiveData.errorCode == 0) {
                                inputObject = {};
                                isNext = {};
                                that.instructionInputList = receiveData.body;
                                that.instructionInputList.map((inputData) => {
                                    if (inputData.default !== null && inputData.default !==
                                        undefined &&
                                        inputData.default !== NaN && inputData.default !== "") {
                                        isNext[inputData.name] = true;
                                        if (inputData.dataType == "uint" && !inputData.selection) {
                                            inputObject[inputData.name] = inputData.default * 1;
                                        } else if (inputData.dataType == "uint" && inputData.selection) {
                                            inputObject[inputData.name] = inputData.default * 1;
                                        } else if (inputData.dataType == "string") {
                                            inputObject[inputData.name] = inputData.default;
                                        } else if (inputData.dataType == "timeStamp") {
                                            inputObject[inputData.name] = inputData.default;
                                        } else if (inputData.dataType == "bool") {
                                            inputObject[inputData.name] = inputData.default;
                                        }
                                    } else {
                                        isNext[inputData.name] = false;
                                    }
                                })
                            } else {
                                that.$Notice.error({
                                    title: "异常",
                                    desc: receiveData.errorInfo
                                });
                            }
                        },
                        error: function(textStatus) {
                            that.$Notice.error({
                                title: "异常",
                                desc: "接口请求异常"
                            });
                        },
                        complete: function() {
                            that.isSpinShow = false;
                        }
                    });
                } else if (that.current == 2) {
                    if (isNextAvaliable() && that.meterIds) {
                        that.showResult = true;
                        that.isButtonShow = false;
                        Object.keys(that.array).map(item => {
                            let inputData = {};
                            inputData["deviceId"] = that.array[item].id;
                            inputData["commandType"] = JSON.parse(that.formSearch.command).down;
                            inputData["command"] = {};
                            inputData.command["paras"] = inputObject;
                            $.ajax({
                                url: "/api/instructions/downInstructionData",
                                contentType: "application/json",
                                type: "post",
                                data: JSON.stringify(inputData),
                                dataType: "json",
                                success: function(receiveData) {
                                    if (receiveData.errorCode == 0) {
                                        that.array[item].state = "下发成功";
                                    } else {
                                        that.array[item].state = receiveData.errorInfo;
                                    }
                                },
                                error: function(textStatus) {
                                    that.$Notice.error({
                                        title: "异常",
                                        desc: "接口请求异常"
                                    });
                                }
                            });
                        })
                    } else {
                        if (!isNextAvaliable()) {
                            that.$Notice.error({
                                title: "异常",
                                desc: "请输入相应参数"
                            });
                        } else if (!that.meterIds) {
                            that.$Notice.error({
                                title: "异常",
                                desc: "无可下发设备"
                            });
                        }
                    }
                }
            },
            request() {
                let that = this;
                that.isSpinShow = true;
                $.ajax({
                    url: "/api/getAddressTree",
                    contentType: "application/json",
                    type: "get",
                    dataType: "json",
                    success: function(data) {
                        if (data.errorCode != 0) {
                            that.$Notice.error({
                                title: "异常",
                                desc: data.errorInfo
                            });
                            return;
                        }
                        that.addressData = data.body[0].children;
                    },
                    error: function(textStatus) {
                        that.$Notice.error({
                            title: "异常",
                            desc: "接口请求异常"
                        });
                    },
                    complete: function() {
                        that.isSpinShow = false;
                    }
                });
            }
        }
    }

    Vue.component('anchored-heading-forlist', {
        render: function(createElement) {
            var self = this;
            var elementExport;
            if (this.inputDatas.length) {
                this.isDownTab = true;
                var brCount = true;
                return createElement('div', this.inputDatas.map(function(inputData) {
                    inputData.value = inputData.default;
                    var inputType = "";
                    if (inputData.dataType == "uint" && !inputData.selection) {
                        inputType = "number";
                        inputObject[inputData.name] = inputData.default * 1;
                    } else if (inputData.dataType == "uint" && inputData.selection) {
                        inputType = "selection";
                        inputObject[inputData.name] = inputData.default * 1;
                    } else if (inputData.dataType == "string") {
                        inputType = "text";
                        inputObject[inputData.name] = inputData.default;
                    } else if (inputData.dataType == "timeStamp") {
                        inputType = "datetime-local";
                        inputObject[inputData.name] = inputData.default;
                    } else if (inputData.dataType == "bool") {
                        inputObject[inputData.name] = inputData.default;
                    }

                    //输入框
                    var elementInput = createElement('Input', {
                        // DOM属性
                        props: {
                            id: inputData.name,
                            value: inputData.value,
                            max: inputData.max,
                            min: inputData.min,
                            type: inputType
                        },
                        style: {
                            display: 'inline-block',
                            fontSize: '15px',
                            width: '150px',
                            height: '20px'
                        },
                        on: {
                            input: function(event) {
                                if (inputData.dataType == "uint") {
                                    inputData.default = event;
                                    inputObject[inputData.name] = parseInt(event);
                                } else if (inputData.dataType == "string") {
                                    inputData.default = event;
                                    inputObject[inputData.name] = event;
                                } else if (inputData.dataType == "timeStamp") {
                                    inputData.default = event;
                                    inputObject[inputData.name] = global.dateFtt(
                                        "yyyy-MM-dd hh:mm:ss", event);
                                }
                                if (event != null && event != "") {
                                    isNext[inputData.name] = true;
                                } else {
                                    isNext[inputData.name] = false;
                                }
                            },
                            'on-blur': function(event) {
                                if (inputData.dataType == "uint") {
                                    if (inputData.max >= 0 && parseInt(event.target
                                            .value) > inputData.max) {
                                        inputData.default = inputData.max;
                                        inputObject[inputData.name] = inputData.default;
                                        isNext[inputData.name] = true;
                                    } else if (inputData.min >= 0 && (parseInt(
                                                event.target.value) < inputData.min ||
                                            event.target.value == "")) {
                                        inputData.default = inputData.min;
                                        inputObject[inputData.name] = inputData.default;
                                        isNext[inputData.name] = true;
                                        console.log(333);
                                    }

                                } else if (inputData.dataType == "string") {} else if (
                                    inputData.dataType == "timeStamp") {}
                            }
                        }
                    }, inputData.default);

                    //小tips

                    var nowOptions = {
                        shortcuts: [{
                            text: '一周前',
                            value() {
                                const date = new Date();
                                date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                                return date;
                            }
                        }, {
                            text: '昨天',
                            value() {
                                const date = new Date();
                                date.setTime(date.getTime() - 3600 * 1000 * 24);
                                return date;
                            }
                        }, {
                            text: '现在',
                            value() {
                                const date = new Date();
                                return date;
                            }
                        }, {
                            text: '明天',
                            value() {
                                const date = new Date();
                                date.setTime(date.getTime() + 3600 * 1000 * 24);
                                return date;
                            }
                        }, {
                            text: '一周后',
                            value() {
                                const date = new Date();
                                date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
                                return date;
                            }
                        }]
                    }
                    //时间选择器
                    var elementDatePicker = createElement('DatePicker', {
                        // DOM属性
                        props: {
                            id: inputData.name,
                            value: inputData.value,
                            type: 'datetime',
                            placeholder: "选择时间",
                            transfer: true,
                            options: nowOptions
                        },
                        style: {
                            display: 'inline-block',
                            fontSize: '15px',
                            width: '150px',
                            height: '20px'
                        },
                        on: {
                            'on-change': function(event) {
                                if (inputData.dataType == "timeStamp") {
                                    inputData.default = event;
                                    inputObject[inputData.name] = event;
                                }
                                if (event != null && event != "" && event !=
                                    undefined) {
                                    isNext[inputData.name] = true;
                                } else {
                                    isNext[inputData.name] = false;
                                }
                            }
                        }
                    });

                    //选择器
                    var selectBool = [{
                            value: true,
                            label: "是"
                        },
                        {
                            value: false,
                            label: "否"
                        }
                    ];

                    if (inputData.cnName == "特征值(标定/复核)") {
                        selectBool = [{
                                value: true,
                                label: "标定"
                            },
                            {
                                value: false,
                                label: "复核"
                            }
                        ];
                    }

                    var elementSelectBool = createElement('Select', {
                        // DOM属性
                        props: {
                            value: (inputData.default || false).toString(),
                            transfer: true
                        },
                        domProps: {},
                        style: {
                            display: 'inline-block',
                            fontSize: '15px',
                            width: '150px',
                            height: '20px'
                        },
                        on: {
                            'on-change': function(event) {
                                inputData.default = event;
                                inputObject[inputData.name] = (event === "true");
                                isNext[inputData.name] = true;
                            }
                        }
                    }, selectBool.map((item) => {
                        return createElement('Option', {
                            props: {
                                value: (item.value || false).toString(),
                                label: item.label
                            }
                        })
                    }))

                    //选择器
                    var selectBanCancel = [{
                            value: 20,
                            label: "计量精度下降"
                        },
                        {
                            value: 6,
                            label: "气表损坏"
                        }
                    ];

                    var elementSelectBanCancel = createElement('Select', {
                        // DOM属性
                        props: {
                            value: inputData.default,
                            transfer: true
                        },
                        domProps: {},
                        style: {
                            display: 'inline-block',
                            fontSize: '15px',
                            width: '150px',
                            height: '20px'
                        },
                        on: {
                            'on-change': function(event) {
                                inputData.default = event;
                                inputObject[inputData.name] = event;
                                if (event != undefined) {
                                    isNext[inputData.name] = true;
                                } else {
                                    isNext[inputData.name] = false;
                                }
                            }
                        }
                    }, selectBanCancel.map((item) => {
                        return createElement('Option', {
                            props: {
                                value: item.value,
                                label: item.label
                            }
                        })
                    }))

                    var elementSpace = createElement('label', {
                        style: {
                            display: 'inline-block',
                            fontSize: '15px',
                            minWidth: '5px',
                            verticalAlign: 'middle',
                            overflow: 'hidden'
                        }
                    })

                    var elementUnit = createElement('label', {
                        style: {
                            display: 'inline-block',
                            fontSize: '15px',
                            maxWidth: '100px',
                            verticalAlign: 'middle',
                            overflow: 'hidden'
                        }
                    }, inputData.unit)


                    var hourOptions = [{
                            value: 0,
                            label: '0'
                        }, {
                            value: 1,
                            label: 1
                        }, {
                            value: 2,
                            label: 2
                        }, {
                            value: 3,
                            label: 3
                        },
                        {
                            value: 4,
                            label: 4
                        }, {
                            value: 5,
                            label: 5
                        }, {
                            value: 6,
                            label: 6
                        }, {
                            value: 7,
                            label: 7
                        },
                        {
                            value: 8,
                            label: 8
                        }, {
                            value: 9,
                            label: 9
                        }, {
                            value: 10,
                            label: 10
                        }, {
                            value: 11,
                            label: 11
                        },
                        {
                            value: 12,
                            label: 12
                        }, {
                            value: 13,
                            label: 13
                        }, {
                            value: 14,
                            label: 14
                        }, {
                            value: 15,
                            label: 15
                        },
                        {
                            value: 16,
                            label: 16
                        }, {
                            value: 17,
                            label: 17
                        }, {
                            value: 18,
                            label: 18
                        }, {
                            value: 19,
                            label: 19
                        },
                        {
                            value: 20,
                            label: 20
                        }, {
                            value: 21,
                            label: 21
                        }, {
                            value: 22,
                            label: 22
                        }, {
                            value: 23,
                            label: 23
                        }
                    ]

                    var minOptions = [{
                        value: 0,
                        label: '0'
                    }, {
                        value: 1,
                        label: 10
                    }, {
                        value: 2,
                        label: 20
                    }, {
                        value: 3,
                        label: 30
                    }, {
                        value: 4,
                        label: 40
                    }, {
                        value: 5,
                        label: 50
                    }]

                    //自定义时间组件 135代表13点50分
                    var elementTime = [
                        //小时
                        createElement('Select', {
                            // DOM属性
                            props: {
                                value: Math.floor(inputData.default / 10),
                                transfer: true
                            },
                            style: {
                                display: 'inline-block',
                                fontSize: '15px',
                                width: '85px',
                                height: '20px'
                            },
                            on: {
                                'on-change': function(event) {
                                    inputData.default = event * 10 + inputData.default %
                                        10;
                                    inputObject[inputData.name] = inputData.default;
                                    isNext[inputData.name] = true;
                                }
                            }
                        }, hourOptions.map((item) => {
                            return createElement('Option', {
                                props: {
                                    value: item.value,
                                    label: item.label
                                }
                            })
                        })),
                        //空格
                        createElement('label', {
                            style: {
                                display: 'inline-block',
                                fontSize: '15px',
                                minWidth: '5px',
                                verticalAlign: 'middle',
                                overflow: 'hidden'
                            }
                        }),
                        createElement('label', {
                            style: {
                                display: 'inline-block',
                                fontSize: '15px',
                                maxWidth: '50px',
                                verticalAlign: 'middle',
                                overflow: 'hidden'
                            }
                        }, inputData.unit),
                        //分
                        createElement('Select', {
                            // DOM属性
                            props: {
                                value: inputData.default % 10,
                                transfer: true
                            },
                            style: {
                                display: 'inline-block',
                                fontSize: '15px',
                                width: '85px',
                                height: '20px'
                            },
                            on: {
                                'on-change': function(event) {
                                    var hour = Math.floor(inputData.default / 10) *
                                        10;
                                    inputData.default = hour + event;
                                    inputObject[inputData.name] = inputData.default;
                                    isNext[inputData.name] = true;
                                }
                            }
                        }, minOptions.map((item) => {
                            return createElement('Option', {
                                props: {
                                    value: item.value,
                                    label: item.label
                                }
                            })
                        })),
                        //空格
                        createElement('label', {
                            style: {
                                display: 'inline-block',
                                fontSize: '15px',
                                minWidth: '5px',
                                verticalAlign: 'middle',
                                overflow: 'hidden'
                            }
                        }),
                        createElement('label', {
                            style: {
                                display: 'inline-block',
                                fontSize: '15px',
                                maxWidth: '50px',
                                verticalAlign: 'middle',
                                overflow: 'hidden'
                            }
                        }, "分")
                    ]

                    if (inputData.dataType == "bool") {
                        elementExport = elementSelectBool;
                    } else if (inputData.dataType == "timeStamp") {
                        elementExport = elementDatePicker;
                    } else if (inputData.cnName == "故障类型") {
                        elementExport = elementSelectBanCancel;
                    } else if (inputData.dataType == "uint" && inputData.selection) {
                        elementExport = createElement('Select', {
                            // DOM属性
                            props: {
                                value: inputData.default,
                                transfer: true
                            },
                            domProps: {},
                            style: {
                                display: 'inline-block',
                                fontSize: '15px',
                                width: '150px',
                                height: '20px'
                            },
                            on: {
                                'on-change': function(event) {
                                    inputData.default = event;
                                    inputObject[inputData.name] = event;
                                    if (event != undefined) {
                                        isNext[inputData.name] = true;
                                    } else {
                                        isNext[inputData.name] = false;
                                    }
                                }
                            }
                        }, inputData.selection.map((item) => {
                            return createElement('Option', {
                                props: {
                                    value: item.value,
                                    label: item.label
                                }
                            })
                        }))
                    } else {
                        elementExport = elementInput;
                    }
                    if (inputData.tip) {
                        elementExport = createElement('Tooltip', {
                            props: {
                                maxWidth: "200",
                                content: inputData.tip,
                                transfer: true,
                                placement: "right"
                            }
                        }, [elementExport])
                    }

                    if (inputData.dataType != "timeStamp" && inputData.name.toLowerCase().search(
                            "time") != -1) {
                        elementExport = null;
                        elementSpace = null;
                        elementUnit = null;
                    } else {
                        elementTime = null;
                    }

                    var widthStyle = "";
                    if (document.body.clientWidth > 1000) {
                        widthStyle = "40%"
                    } else {
                        widthStyle = "80%"
                    }
                    return createElement('div', // 标签名称
                        {
                            style: {
                                float: 'left',
                                width: widthStyle,
                                height: "35px"
                            }
                        },
                        [ // 输入框中文名
                            createElement('label', {
                                style: {
                                    display: 'inline-block',
                                    fontSize: '15px',
                                    width: '150px',
                                    verticalAlign: 'middle',
                                    overflow: 'hidden'
                                }
                            }, inputData.cnName),
                            //输入框
                            elementExport,
                            // 空格
                            elementSpace,
                            //单位
                            elementUnit
                        ].concat(elementTime));
                }))
            } else {
                this.isDownTab = true;
                return createElement('p', '确认重置请直接下一步，否则请返回');
            }
        },
        props: ["inputDatas"]
    })

    function isNextAvaliable() {
        var temp = true;
        for (var val in isNext) {
            temp = temp && isNext[val]; //输出如:name 
        }
        return temp;
    }
</script>

<style>
</style>
